import { type ReactElement } from 'react';
import { type TAPlan } from '../../TAPlan/TAPlan.types';
import { taPlan } from '../LayerFactories/TAPlan';
import { LeafletMap } from '../Map';
import { StaticSource } from '../Sources/StaticSource';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

interface TAPlanDetailsPageMapProps extends PageMapProps {
    taPlan: TAPlan;
}

export const TAPlanDetailsPageMap = (props: TAPlanDetailsPageMapProps): ReactElement => {
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        taPlan({
            source: new StaticSource([
                {
                    id: props.taPlan.id,
                    type: 'Feature',
                    geometry: props.taPlan.wgs84Position,
                    properties: { ...props.taPlan },
                },
            ]),
            name: 'TAPlan',
            disablePopup: true,
            animate: false,
        }).addTo(map);
    };

    return <LeafletMap {...mapProps} disableFullscreenControl={true} startOnFeatureBounds={true} onMapInitiated={setupMap} />;
};
